require('./bootstrap');

import 'jquery-ui/ui/widgets/autocomplete.js';

var logo = {
  init: function(){
    /* fit logo to social */
    var wlogo = $('.header-logo').width();
    var wsocial = $('.social-link').outerWidth() * $('.social-link').length;
    if(wsocial > wlogo) {
      var offset = (wsocial - wlogo) / 4;
      $('.header-logo').css('transform', `translateX(${offset}px)`)
    }
    $('.header-logo').css('opacity', 'initial')
  }
}
logo.init();

var toolbar = {

  init: function() {

    $('.toolbar').each(function(index, el) {

      var labels = $(el).find('.toolbar-label');

      var maxwidth = 0;
      for (var i = labels.length - 1; i >= 0; i--) {
        var text = $(labels[i]).text().trim();

        var curlength = text.length * 10;
        maxwidth = curlength > maxwidth ? curlength : maxwidth;
      }

      maxwidth = maxwidth < 200 ? 200 : maxwidth;
      
      $(el).data('maxwidth', maxwidth);

    });

    $('.toolbar-link').hover(function() {
      var self = $(this);
      clearTimeout(toolbar.timeout);
      toolbar.timeout = setTimeout(function() {
        $('.toolbar-label').width(self.parent().data('maxwidth'));
        self.parent().parent().children().not('.toolbar').addClass('toolbar-fade');
      }, 380);
    }, function() {
      var self = $(this);
      clearTimeout(toolbar.timeout);
      toolbar.timeout = setTimeout(function() {
        $('.toolbar-label').width(0);
        self.parent().parent().children().not('.toolbar').removeClass('toolbar-fade');
      }, 380);
    });

    $('.toolbar').hover(function() {}, function() {
      var self = $(this);
      clearTimeout(toolbar.timeout);
      $('.toolbar-label').width(0);
      self.parent().children().not('.toolbar').removeClass('toolbar-fade');
    });

    $('.toolbar-toggle').click(function(event) {
      $(this).parent().find('.toolbar-link').toggleClass('toolbar-link-visible');
    });

    $('.toolbar-link').click(function(event) {
      clearTimeout(toolbar.timeout);
    });
  }
}
toolbar.init();


var toggles = {
  init: function() {

    $('input[type="checkbox"]').change(function(event) {
      
      $( "#" + $(this).data('linkedto') ).prop('checked', $(this).is(':checked'));


    });

  }
}
toggles.init();

var sidebar = {
  slide: false,

  slideIn: function(){
    var self = this;
    $('.sidebar-overlap').fadeIn('fast');
    $('.sidebar').animate({
        right: '0',
      },
      'fast',
      function() {
        self.slide = true;
        $('html').addClass('scroll-max-md-lock');
        $('body').addClass('scroll-max-md-lock');
      }
    );
  },

  slideOut: function(attachedReadyFunction) {
    var self = this;
    $('.sidebar-overlap').fadeOut('fast');
    $('.sidebar').animate({
        right: $(window).width() + 'px',
      },
      'fast',
      function(){
        self.slide = false;
        $('html').removeClass('scroll-max-md-lock');
        $('body').removeClass('scroll-max-md-lock');
        if(attachedReadyFunction) attachedReadyFunction();
      }
    );
  },

  init: function() {
    var self = this;
    
    $('body *').first().before('<div class="sidebar-overlap d-md-none" style="display:none;"> </div>');
    $('.sidebar-toggler').click(function(event) {
      event.preventDefault();
      if(!$(this).hasClass('sidebar-toggler')) return;
      self.slideIn();
    });

    $('.sidebar').click(function(event) {
      if($(event.target).hasClass('sidebar')){
        self.slideOut();
      }
    });

    this.slideOut(function(){
      $('.sidebar').show();
    });

    $(window).resize(function(event){
      var right = self.slide ? '0' : $(window).width()+'px';

      $('.sidebar').css({
        right: right,
      });
    });

    /*$(window).resize(function(event) {      

      if(!self.slide) self.slide = 0;
      var right = self.slide ? '0' : $(window).width()+'px';

      $('.sidebar').css({
        right: right,
      });

      $('.sidebar-overlap').hide();
    });*/
  }
}.init();


var selectors = {

  clear: function($selector) {
    $selector.prop('disabled', true).addClass('bg-light');
    $selector.html(`<option value="" selected disabled>${$('#catalogLoading').text().trim()}...</option>`)
  },

  clearFull: function($selector) {
    $selector.prop('disabled', true).addClass('bg-light');
    $selector.html('');
  },

  setIdle: function($selector, status) {
    var $span = $selector.parent().find('span');
    status ? $span.removeClass('alpha') : $span.addClass('alpha');
  },

  reset: function($selector) {
    $selector.children(':first').prop('selected', true);
  }
};

var catalog = {

  fillStep1: function(attachedReadyFunction) {
    $('.assist-submit').removeClass('btn-primary').addClass('bg-light border disabled');
    // selectors.displayerror(false);

    var $selector = $('#assist-step-2');

    selectors.clear($selector);
    selectors.clearFull($('#assist-step-3'));
    selectors.clearFull($('#assist-step-4'));
    selectors.clearFull($('#assist-step-5'));


    selectors.setIdle($selector, true);

    $.ajax({
      url: `/${$('html').attr('lang')}/catalog/1`,
      type: 'POST',
      data: {year_id: $('#assist-step-1').val()},
    })
    .done(function(data) {
      $selector.html('');      
      $selector.append(`<option value="" selected disabled>${$selector.parent().find('.select-header').text()}</option>`);
      for (var i = 0; i < data.length; i++) {
        $selector.append(`<option value="${data[i].id}">${data[i].val}</option>`);
      }
      $selector.prop('disabled', false).removeClass('bg-light');
      selectors.setIdle($selector, false);

      $selector.focus();

      $('.assist-container').show();

      if(attachedReadyFunction) attachedReadyFunction();

    })
    .fail(function() {
      // selectors.displayerror(true);
      selectors.clearFull($selector);
      selectors.reset($('#assist-step-1'));
      selectors.setIdle($selector, false);
    });
  },

  fillStep2: function(attachedReadyFunction) {
    $('.assist-submit').removeClass('btn-primary').addClass('bg-light border disabled');
    // selectors.displayerror(false);

    var $selector = $('#assist-step-3');
    selectors.clearFull($('#assist-step-4'));
    selectors.clearFull($('#assist-step-5'));

    selectors.clear($selector);
    selectors.setIdle($selector, true);

    $.ajax({
      url: `/${$('html').attr('lang')}/catalog/2`,
      type: 'POST',
      data: {
        year_id:  $('#assist-step-1').val(),
        marca_id: $('#assist-step-2').val()
      },
    })
    .done(function(data) {
      $selector.html('');      
      $selector.append(`<option value="" selected disabled>${$selector.parent().find('.select-header').text()}</option>`);
      for (var i = 0; i < data.length; i++) {
        $selector.append(`<option value="${data[i].id}">${data[i].val}</option>`);
      }
      $selector.prop('disabled', false).removeClass('bg-light');

      selectors.setIdle($selector, false);
      if(attachedReadyFunction) attachedReadyFunction();

    })
    .fail(function() {
      // selectors.displayerror(true);
      selectors.clearFull($selector);
      selectors.reset($('#assist-step-2'));
      selectors.setIdle($selector, false);
    });
  },

  fillStep3: function(attachedReadyFunction) {
    $('.assist-submit').removeClass('btn-primary').addClass('bg-light border disabled');
    // selectors.displayerror(false);

    var $selector = $('#assist-step-4');
    selectors.clearFull($('#assist-step-5'));

    selectors.clear($selector);
    selectors.setIdle($selector, true);

    $.ajax({
      url: `/${$('html').attr('lang')}/catalog/3`,
      type: 'POST',
      data: {
        year_id:      $('#assist-step-1').val(),
        marca_id:     $('#assist-step-2').val(),
        modelo_id:    $('#assist-step-3').val().split('-')[0],
        submodelo_id: $('#assist-step-3').val().split('-')[1]
      },
    })
    .done(function(data) {
      $selector.html('');      
      $selector.append(`<option value="F-F" selected>${$selector.parent().find('.select-header').text()}</option>`);
      for (var i = 0; i < data[0].length; i++) {
        $selector.append(`<option value="${data[0][i].id}">${data[0][i].val}</option>`);
      }
      $selector.prop('disabled', false).removeClass('bg-light');

      var $selector2 = $('#assist-step-5');
      $selector2.html('');      
      $selector2.append(`<option value="F" selected>${$selector2.parent().find('.select-header').text()}</option>`);
      for (var i = 0; i < data[1].length; i++) {
        $selector2.append(`<option value="${data[1][i].id}">${data[1][i].singular}</option>`);
      }
      $selector2.prop('disabled', false).removeClass('bg-light');

      $('.assist-submit').removeClass('bg-light border disabled').addClass('btn-primary');

      selectors.setIdle($selector, false);
      if(attachedReadyFunction) attachedReadyFunction();

    })
    .fail(function() {
      // selectors.displayerror(true);
      selectors.clearFull($selector);
      selectors.reset($('#assist-step-3'));
      selectors.setIdle($selector, false);
    });
  },

  fillStep4: function(attachedReadyFunction) {
    $('.assist-submit').removeClass('btn-primary').addClass('bg-light border disabled');
    // selectors.displayerror(false);

    var $selector = $('#assist-step-5');

    selectors.clear($selector);
    selectors.setIdle($selector, true);

    $.ajax({
      url: `/${$('html').attr('lang')}/catalog/4`,
      type: 'POST',
      data: {
        year_id:      $('#assist-step-1').val(),
        marca_id:     $('#assist-step-2').val(),
        modelo_id:    $('#assist-step-3').val().split('-')[0],
        submodelo_id: $('#assist-step-3').val().split('-')[1],
        litros_id:    $('#assist-step-4').val().split('-')[0],
        cilindros_id: $('#assist-step-4').val().split('-')[1]
      },
    })
    .done(function(data) {
      $selector.html('');      
      $selector.append(`<option value="F" selected>${$selector.parent().find('.select-header').text()}</option>`);
      for (var i = 0; i < data.length; i++) {
        $selector.append(`<option value="${data[i].id}">${data[i].singular}</option>`);
      }
      $selector.prop('disabled', false).removeClass('bg-light');

      $('.assist-submit').removeClass('bg-light border disabled').addClass('btn-primary');
      selectors.setIdle($selector, false);

      if(attachedReadyFunction) attachedReadyFunction();

    })
    .fail(function() {
      // selectors.displayerror(true);
      selectors.clearFull($selector);
      selectors.reset($('#assist-step-4'));
      selectors.setIdle($selector, false);
      
    });
  },

  init : function() {
    var self = this;

    $('#assist-step-1').change(function(event, attFun){
      $(this).find('option').removeAttr('selected');
      $(this).find(":selected").attr('selected', true);
      self.fillStep1(attFun);
    });

    $('#assist-step-2').change(function(event, attFun){
      $(this).find('option').removeAttr('selected');
      $(this).find(":selected").attr('selected', true);
      self.fillStep2(attFun);
    });

    $('#assist-step-3').change(function(event, attFun){
      $(this).find('option').removeAttr('selected');
      $(this).find(":selected").attr('selected', true);
      self.fillStep3(attFun);
    });

    $('#assist-step-4').change(function(event, attFun){
      $(this).find('option').removeAttr('selected');
      $(this).find(":selected").attr('selected', true);
      self.fillStep4(attFun);
    });

    $('#assist-form').submit(function(event) {
      event.preventDefault();
      var val1 = $('#assist-step-1').val();
      var val2 = $('#assist-step-2').val();
      var val3 = $('#assist-step-3').val();
      var val4 = $('#assist-step-4').val();
      var val5 = $('#assist-step-5').val();
      window.location.href = `/${$('html').attr('lang')}/catalog/${val1}-${val2}-${val3}-${val4}-${val5}`;
    });

    self.translateclass = $('.assist-container').hasClass('top-content-translate') ? ' top-content-translate' : '';
    self.marginclass = $('.assist-container').hasClass('mt-assist') ? ' mt-assist' : '';

    var location = window.location.href.split('/');


    var tags = $('.box-tags span')
    var availableTags = []
    for (var i = 0; i < tags.length; i++) {
      availableTags.push( $(tags[i]).text().trim() );
    }

    $('.box-catalog').autocomplete({
      minLength: 0,
      source: availableTags,
      open: function(){
        $(this).autocomplete('widget').css('z-index', 1051);
        return false;
      },
      select: function(data, object) {
        $(this).blur();

        var value = object.item.value;
        var id;
        $('#assist-step-1 option').each(function(index, el) {

          if($(el).text().trim() == value){
            id = $(el).val().trim();
            return;
          }

        }).promise().done(function(){

          $('#assist-form').css({'box-shadow': '0px 0px 3px 0px #0e84cf'});
          
          clearTimeout(catalog.timeout);
          clearTimeout(catalog.timeout2);
          catalog.timeout = setTimeout(function() {
            $('#assist-form').css({'box-shadow': 'none', 'transition': 'box-shadow 1s ease-in-out'});
            catalog.timeout2 = setTimeout(function() {$('#assist-form').removeAttr('style');}, 1000);
          }, 500);


          $('.assist-container').slideDown(200, function() {
            $('#assist-step-1').val(id).trigger('change');
          });

          $("html, body").animate({ scrollTop: $('#assist-container').offset().top - 60 }, 200);


        });
      },

      appendTo: $('.box-catalog').parent(),

    }).focus(function(event) {
      $(this).val('');
      $(this).autocomplete("search");
      $(this).attr('placeholder', 'Selecciona un año');
    }).focusout(function(event) {
      $(this).attr('placeholder', 'Catálogo en línea');
    });

    $('.box-toggle').click(function(event) {
      $('.box-catalog').focus();
    });

    
    jQuery(document).ready(function($) {
      
      $('.persistent-input').each(function(index, el) {

        var target =$(el).data('target');
        var val = $(el).val();

        $(target).val(val);

      });

    });

  }
}; catalog.init();


var search = {

  init: function() {
    $('#global_search').autocomplete({
      minLength: 2,

      open: function(){
        $(this).autocomplete('widget').css('z-index', 1051);
        return false;
      },

      select: function(data, object) {
        window.location.href = object.item.url
      },

      source: function(request,response){
        $.ajax({
          url: `/${$('html').attr('lang')}/autocomplete`,
          type:"GET",
          headers: {
            Accept: 'application/json'
          },
          data:{
            q: request.term,
          },                    
          success:function(data){
            response($.map(data, function (item) {
              if(item.aplicacion[0]) {
                var submodelo = item.aplicacion[0].vehiculo.submodelo.val ? item.aplicacion[0].vehiculo.submodelo.val : ''
                var aplicacion = $('<small>').append(' · ').append(
                ).append(
                  $('<span>').text(item.categoria.singular + ' ' + (item.descripcion ? item.descripcion : '')).append('<br>')
                ).append(
                  $('<strong>').text(item.aplicacion[0].vehiculo.marca.val + ' ' + item.aplicacion[0].vehiculo.modelo.val + ' ' + submodelo)
                ).append(
                  $('<span>').text(item.aplicacion[0].rango.join(','))
                )
                .append(
                  $('<span>').text(' ' + item.aplicacion[0].motor)
                )
              }

              var label = $('<div>').addClass('border-bottom').append(
                $('<span>').addClass('font-weight-bold text-primary').text(item.codigo)
              );

              if(item.aplicacion[0]) label.append(
                $('<span>').addClass('text-muted').append(aplicacion)
              )

              return {
                label: label,
                value: item.codigo,
                url:   item.url
              }
            }))
          }
        })
      },

      appendTo: $("#global_search").parent().parent(),

    }).data("ui-autocomplete")._renderItem = function (ul, item) {
       return $('<li></li>')
       .data("item.autocomplete", item)
       .append(
          $('<a>').addClass('d-block text-decoration-none').append(item.label)
        )
       .appendTo(ul);
    };


    $('.search-toggle').click(function(event) {
      event.preventDefault();
      $('.search-column').removeClass('d-none');
      $('.header-column').addClass('d-none');
      $('#global_search').focus();
    });

    $('#global_search').blur(function(event) {
      event.preventDefault();
      $('.search-column').addClass('d-none');
      $('.header-column').removeClass('d-none');
    });

  }
}

search.init();

const extensions = {

  init: function() {
    $.ajaxSetup({
      headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
      }
    });

    $('.cookies-dismiss').click(function(event) {
      event.preventDefault();
      $.ajax({
        url: '/accept-cookies',
        type: 'POST',
      });

      $('.cookies-info').slideUp();
    });

    $('.btn-quote').prepend('<div class="btn-quote-square"></div>');

    $('.btn-chat').click(function(event) {
      $(this).fadeOut();
      $('.chat-container').slideDown();
    });

    $('.btn-chat-dismiss').click(function(event) {
      $('.chat-container').slideUp();
      $('.btn-chat').fadeIn();
    });

    $('[data-toggle="popover"]').popover();


    $.fn.selectRange = function(start, end) {
      if(end === undefined) {
        end = start;
      }
      return this.each(function() {
        if('selectionStart' in this) {
          this.selectionStart = start;
          this.selectionEnd = end;
        } else if(this.setSelectionRange) {
          this.setSelectionRange(start, end);
        } else if(this.createTextRange) {
          var range = this.createTextRange();
          range.collapse(true);
          range.moveEnd('character', end);
          range.moveStart('character', start);
          range.select();
        }
      });
    };

    $(function() {

      $('[data-toggle="dropdown"]').on('click', function(event) {
        event.preventDefault();

        var showing = $('.dropdown-menu.show');
        var trigger = showing.parent().find('[data-toggle="dropdown"]');
        var self = this;

        if(trigger.length && trigger[0] != self) {
          showing.fadeOut(0, function(){
            $(self).parent().find('.dropdown-menu').toggle();
          })
        }
        else{
          $(self).parent().find('.dropdown-menu').toggle();
        }

        
      });

      $('.dropdown-menu').on('click', function(event) {
        event.stopPropagation();
      });

      $(window).on('click', function(event) {
        $('.dropdown-menu').hide();
      });

    });


  },
}
extensions.init();